module.exports = __webpack_public_path__ + "img/binding4.0c3d8a01.jpg";